import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { CeoUserDetailComponent } from './ceo-user-detail.component';
import { CeoContactModalComponent } from '../ceo-contact-modal/ceo-contact-modal.component';
import { CeoEmailPreviewComponent } from '../ceo-email-preview/ceo-email-preview.component';
import { CeoPolishButtonComponent } from '../ceo-polish-button/ceo-polish-button.component';
import { CeoSenderPickerComponent } from '../ceo-sender-picker/ceo-sender-picker.component';
import { CeoV2WriteComponent } from '../../ceo-v2/write/ceo-v2-write.component';
import { CeoV2MarkupsComponent } from '../../ceo-v2/markups/ceo-v2-markups.component';

/**
 * The customer slide-over, in a module of its own so it can be rendered outside the
 * CEO area.
 *
 * ⚠️ IT EXISTS BECAUSE THE SUPPORT CHAT NEEDS IT AND LIVES IN `AppModule`, while the
 * CEO pages are a lazy module. A component can only be declared once, so the two
 * consumers share it through here rather than either duplicating the panel or
 * dragging the whole (chart-heavy) `CeoModule` into the eager bundle.
 *
 * Only what the panel's own template uses is imported: `*ngIf`/pipes (CommonModule),
 * the credit and plan forms (FormsModule) and `ion-spinner` (IonicModule).
 */
@NgModule({
  // The contact modal and the email preview live here too: the panel opens the modal
  // wherever the panel is rendered (CEO pages AND the support chat), and /ceo/emails
  // reuses the preview through CeoModule's import of this module.
  // The v2 write (second factor) lives here so the panel's cost-markup card (A6.44) can use it; CeoModule gets it back.
  declarations: [CeoUserDetailComponent, CeoContactModalComponent, CeoEmailPreviewComponent, CeoPolishButtonComponent, CeoSenderPickerComponent, CeoV2WriteComponent, CeoV2MarkupsComponent],
  imports: [CommonModule, FormsModule, IonicModule, RouterModule],
  exports: [CeoUserDetailComponent, CeoContactModalComponent, CeoEmailPreviewComponent, CeoPolishButtonComponent, CeoSenderPickerComponent, CeoV2WriteComponent],
})
export class CeoUserDetailModule {}
